import { render, staticRenderFns } from "./SJWRYLAB.vue?vue&type=template&id=db91e952&scoped=true"
import script from "./SJWRYLAB.vue?vue&type=script&lang=js"
export * from "./SJWRYLAB.vue?vue&type=script&lang=js"
import style0 from "./SJWRYLAB.vue?vue&type=style&index=0&id=db91e952&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db91e952",
  null
  
)

export default component.exports